"use strict";

(function() {
    const DEFAULT = "en";
    const DELIMITER = ".";
    
    const LocaleManager = function(translations) {
        // The JSON object of translations
        this.locale = translations;
        // The selected locale
        this.selected = DEFAULT;
    };

    // Returns the selected key in the current locale
    // Accepts a string delimited by dots (".")
    // ex: get("menu.buttons.cancel") will return the value of "cancel" in the current locale 
    LocaleManager.prototype.get = function(keys) {
        var value = find(this.locale, keys.split(DELIMITER));

        if (!value.hasOwnProperty(this.selected)) {
            throw new ReferenceError(keys + " is not defined for language " + this.selected);
        }

        return value[this.selected];
    };

    // Swap the current locale to a given one
    // TODO: check if the locale is available
    LocaleManager.prototype.switch = function(lang) {
        this.selected = lang;
    };

    // Recursive function that takes an array of keys and loops through the object to get the last key of the array
    // ex: menu.buttons.cancel with return the cancel object
    function find(o, keys) {
        var current = keys.shift();

        if (current && o.hasOwnProperty(current.toLowerCase())) {
            return find(o[current], keys);
        }

        return o;
    }

    window.LocaleManager = LocaleManager;
    
}());
